// extracted by mini-css-extract-plugin
export default {"header":"TariffHeader_header__13BZ0","title":"TariffHeader_title__hXPqV","period":"TariffHeader_period__Blldj"};